export interface TarificationState {
    tariffZones: TariffZoneItem[],
    tariffZone?: TariffZoneItem,
    tariffZoneGroup?: TariffZoneGroupItem,
    tariffs: TariffItem[],
    tariff?: TariffItem,
}

export interface TariffZoneFilter {
    id?: number,
    name?: string,
    msisdn?: string,
    mcc?: string,
    mnc?: string,
    price?: string,
    status?: number,
}

export interface TariffZoneItem {
    id?: number,
    name: string,
    msisdn?: string,
    mcc?: string,
    mnc?: string,
    price?: string
    message_categories_prices?: { price?: string, message_category_id?: number | undefined } [],
    status: number,
}


export interface TariffZoneGroupItem {
    id?: number,
    charging: string,
    routing: string,
    is_all_operators_allowed?: boolean,
    operators?: AllowedOperatorItem[],
}

export interface AllowedOperatorItem {
    id?: number,
    name?: string,
    is_allowed?: boolean,
}

export interface ImportZonesItem {
    name?: string,
    file?: any,
    delimiter: string,
    uniqueness_policy?: number,
}
export interface ImportTariffsItem {
    name?: string,
    file?: any,
    delimiter: string,
    uniqueness_policy?: number,
}

export enum TarificationTypes {
    PARTNER = 'partners', OPERATOR = 'service_providers'
}

export enum TarificationTransports {
    SMS = 'SMS', CALL = 'Call',
    EMAIL = 'Email', PUSH = 'Push',
    VIBER = 'Viber', WHATSAPP = 'WhatsApp',
    MAILNOTIFY = 'Mail Notify',
    CUSTOM = 'Custom',
}

export interface TariffFilterParams {
    price?: string,
    partner?: string,
    service_provider?: string,
}

export interface TariffItem {
    id?: number,
    partner?: string,
    partner_id?: number,
    service_provider?: string,
    service_provider_id?: number,
    price?: string,
    message_categories_prices?: { price?: string, message_category_id?: number | undefined } [],
}

export class TariffZoneGroupItemImpl implements TariffZoneGroupItem {
    charging: string;
    id?: number;
    is_all_operators_allowed: boolean;
    operators?: AllowedOperatorItem[];
    routing: string;

    constructor() {
        this.charging = '';
        this.routing = '';
        this.is_all_operators_allowed = true;
    }
}
